import React from 'react'
import Whowe from '../components/HomePage/Whowe'
import DigitalCapabilities from '../components/HomePage/DigitalCapabilities'
import WhySan from '../components/HomePage/WhySan'
import DigitalProduct from '../components/HomePage/DigitalProduct'
import WhatNext from '../components/HomePage/WhatNext'
import HowWork from '../components/HomePage/HowWork'
import Explore from '../components/HomePage/Explore'
import { SEO } from '../utils/SEO'

export default function LandingPage() {

  SEO({
    title: 'SAN Technovation | IT, Embedded & IoT Solutions Company',

    description:
      'SAN Technovation is a leading IT solutions company in Erode delivering custom software development, web development, mobile app development, embedded systems, IoT solutions, UI/UX design, ATS, HRMS, LMS, and business automation services.',

    keywords:
      'SAN Technovation, IT Solutions Company, IT Company in Erode, Software Development, Custom Software Development, Web Development, Mobile App Development, Embedded Systems, Embedded Solutions, IoT Solutions, Industrial IoT, UI UX Design, Business Automation, Enterprise Software, Digital Transformation, CareerConnect ATS, CareerConnect AI, SAN HRMS, SAN LMS, ATS Software, HRMS Software, LMS Software, MERN Stack Development',

    author: 'SAN Technovation',

    ogTitle:
      'SAN Technovation | IT, Embedded & IoT Solutions Company',

    ogDescription:
      'SAN Technovation is a leading IT solutions company in Erode specializing in software development, embedded systems, IoT solutions, web and mobile applications, ATS, HRMS, LMS, UI/UX design, and business automation services.',

    ogType: 'website',

    ogSiteName: 'SAN Technovation',

    canonical: 'https://www.santechnovation.com'
  })
  return (
    <main>
      <Explore />
      <Whowe />
      <DigitalCapabilities />
      <HowWork />
      <WhySan />
      <DigitalProduct />
      <WhatNext />
    </main>
  )
}

